// Nivel de Servicio se captura por planta. Cuando el usuario no tiene una planta fija, el backend
// responde el promedio simple de las plantas en `capture.real_level` (puede ser fraccionario, p. ej. 3.67)
// y el detalle por planta en `capture.plants`. Ese promedio no es un nivel capturable (1 a 4): mostrarlo en
// un selector de niveles lo deja en blanco ("Sin capturar").

/**
 * Qué mostrar en el Real de un indicador.
 * - plain: sin desglose por planta (otros pilares, o evaluador con planta fija). Valor editable tal cual.
 * - plant: hay desglose y el usuario eligió una planta; se edita el valor de esa planta.
 * - average: hay desglose y no hay planta elegida; el promedio es solo de lectura.
 */
export function plantRealView(cap, plantSel) {
  const plants = Array.isArray(cap?.plants) ? cap.plants : [];
  if (plants.length === 0) return { kind: "plain", value: cap?.real_level ?? "", count: 0 };
  if (plantSel) {
    const own = plants.find((p) => p.plant === plantSel);
    return { kind: "plant", value: own?.real_level ?? "", count: plants.length };
  }
  return { kind: "average", value: cap?.real_level ?? "", count: plants.length };
}

/** Un nivel o un promedio con a lo más 2 decimales; "" si no hay valor. */
export function formatLevel(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? String(Math.round(n * 100) / 100) : "";
}

/** Diferencia Real - Objetivo sin ruido de coma flotante (el promedio puede dar 0.6666…). */
export function levelGap(real, objetivo) {
  return Math.round(((Number(real) || 0) - (Number(objetivo) || 0)) * 100) / 100;
}
